module.exports = __webpack_public_path__ + "static/img/class-end.853507cf.png";